<h1 class="sr-only" i18n="sr-only@@footer.header">Fusszeile</h1>
<h2 class="sr-only" i18n="sr-only@@footer.linkHeader">Metainformationen</h2>

<ul class="navbar-nav vertical horizontal-sm">
  <li class="nav-item"><a
    class="nav-link"
    href="https://www.clea.app/"
    i18n="@@footer.link.cleaHome"
    i18n-href="@@www-clea-app"
    target="_blank"
  >CléA Assistenzplattform</a></li>
  <li class="nav-item"><a
    class="nav-link"
    href="https://www.clea.app/ueber-uns/"
    i18n="@@footer.link.aboutUs"
    i18n-href="@@www-clea-app-ueber-uns"
    target="_blank"
  >Über uns</a></li>
  <li class="nav-item"><a
    class="nav-link"
    href="https://www.clea.app/medien/"
    i18n="@@footer.link.press"
    i18n-href="@@www-clea-app-medien"
    target="_blank"
  >Medien</a></li>
  <li class="nav-item"><a
    class="nav-link"
    href="https://www.clea.app/datenschutzerklaerung-clea-assistenzplattform/"
    i18n="@@footer.link.privacy"
    i18n-href="@@www-clea-app-datenschutzerklaerung-clea-assistenzplattform"
    target="_blank"
  >Datenschutz</a></li>
  <li class="nav-item"><a
    class="nav-link"
    href="https://www.clea.app/impressum/"
    i18n="@@footer.link.legalNotice"
    i18n-href="@@www-clea-app-impressum"
    target="_blank"
  >Impressum</a></li>
</ul>

<div class="navbar-nav vertical horizontal-sm">
  <div (click)="toggleLangSwitcher()" [class]="activeSwitcher ? 'active' : ''" class="language-switcher">
    <button class="language-switcher__btn button tertiary" type="button">
      <span [class]="activeSwitcher ? 'icon-chevron-up' : 'icon-chevron-down'" aria-hidden="true"
      class="icon icon-chevron-down"></span>
      {{ siteLocale.label }}
    </button>
    <ul class="language-switcher__ul">
      @for (lang of languageList; track lang) {
        <li class="language-switcher__list">
          <a (click)="toggleLang($event, lang)" [class]="lang.code === siteLocale.code ? 'active' : ''"
          [href]="lang.url">{{ lang.label }}</a>
        </li>
      }
    </ul>
  </div>

  <div class="footer-links-block">
    <a
      class="donation-button d-none d-sm-flex"
      href="https://www.clea.app/spenden/"
      i18n="@@footer.link.donate"
      i18n-href="@@www-clea-app-spenden"
      target="_blank"
    >Spenden</a>
    <a
      class="button tertiary"
      href="https://www.clea.app/faq-zur-clea-assistenzplattform/"
      i18n-href="@@www-clea-app-faq-zur-clea-assistenzplattform"
      target="_blank"
      >
      <span aria-hidden="true" class="icon icon-help-circle"></span>
      <ng-container i18n="@@footer.link.help">Hilfe</ng-container>
    </a>
    <a [href]="emailFeedbackPlatfrom" class="button tertiary block">
      <span aria-hidden="true" class="icon icon-message-circle"></span>
      <ng-container i18n="@@footer.link.feedback">Feedback</ng-container>
    </a>
  </div>
  <a class="donation-button button block d-sm-none" href="https://www.clea.app/spenden/"
  i18n="@@footer.link.donate" i18n-href="@@www-clea-app-spenden" target="_blank">Spenden</a>
</div>
